module.exports = __webpack_public_path__ + "img/sequire.6b1b2088.png";